import {
	getIdentity,
	useAuth0,
	IdentityGrantCookie,
	storeUserId,
	retrieveStoredUserId,
} from '@equipmentshare/auth0-react'
import { UniversalHeaderConsumable } from '@equipmentshare/universal-header'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import config from 'config/config'
import { getUniversalHeaderConfig } from 'config/unav'

// Create a QueryClient for the universal header (using @tanstack/react-query v5)
const universalHeaderQueryClient = new QueryClient()

export default function AppHeader(): JSX.Element {
	const auth0 = useAuth0()

	const logout = () => {
		auth0.logout( {
			returnTo: window.location.origin,
			client_id: config.AUTH0_CLIENTID,
		} )
	}

	const tokenGetter = async() => {
		const { accessToken, idToken } = await getIdentity( auth0 )
		return { accessToken, idToken }
	}

	const { app, environment, helpOverride } = getUniversalHeaderConfig()

	return (
		<QueryClientProvider client={universalHeaderQueryClient}>
			<UniversalHeaderConsumable
				environment={environment}
				app={app}
				helpOverride={helpOverride}
				logout={logout}
				tokenGetter={tokenGetter}
				getStoredActiveUserId={retrieveStoredUserId}
				setStoredActiveUserId={storeUserId}
				writeIdentityGrantCookie={IdentityGrantCookie.write}
			/>
		</QueryClientProvider>
	)
}
